export default "__VITE_ASSET__lHATXdKK__"